import React from 'react'

import type { PageSwoosh } from '@constants/enums/swoosh'

interface ISectionContext {
  isHero?: boolean
  // We rely on isH1Section section to determine which section should contain an H1
  isH1Section?: boolean
  indexInPage?: number
  isGrouped?: boolean
  hasGroupHeading?: boolean
  sectionGroupSwoosh?: PageSwoosh
  isTrustedBySection?: boolean
}

export const SectionContext = React.createContext<ISectionContext>({})
